module.exports = __webpack_public_path__ + "static/img/404.63020eb9.png";